import Vue from 'vue'
import router from '@/router'
import store from '@/store/'
import { ACCESS_TOKEN, USER_ROLE } from "@/store/mutation-types";
import HomeLayout from './layouts/HomeLayout'
import classRoomLayout from './layouts/classRoomLayout'
import mockTestLayout from './layouts/mockTestLayout'
import xinaoZoneLayout from './layouts/xinaoZoneLayout'
import FullScreenLayout from './layouts/FullScreenLayout'
import BlankLayout from '@/components/layouts/BlankLayout'

const whiteList = ['/user/login', '/home'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  console.log(Vue.ls.get(ACCESS_TOKEN));
  if (Vue.ls.get(ACCESS_TOKEN)) {
    next()
  } else {
    if (whiteList.indexOf(to.path) == -1) {
      next()
      // next({ path: '/user/login', query: { redirect: to.fullPath, role: Vue.ls.get(USER_ROLE) } })
    } else {
      next()
    }
  }
})

let tenantConfig = store.getters.tenantInfo

/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  {
    path: '/',
    component: HomeLayout,
    redirect: tenantConfig && tenantConfig.home || '/index',
    hidden: true,
    children: [
      {
        path: '/index',
        name: 'index',
        component: () => import(/* webpackChunkName: "wuge" */ './views/index'),
        meta: { title: '首页' }
      },

    ]
  },
  // classroom
  {
    path: '/user',
    component: classRoomLayout,
    redirect: '/user/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/home'),
        meta: { title: '教室首页' }
      }, {
        path: 'myClass',
        name: 'myClass',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/myClass'),
        meta: { title: '班级管理' }
      }, {
        path: 'studentList',
        name: 'studentList',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/StudentList'),
        meta: { title: '学生管理' }
      }, {
        path: 'teacherList',
        name: 'teacherList',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/TeacherList'),
        meta: { title: '教师管理' }
      }, {
        path: 'studentMyclass',
        name: 'studentMyclass',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/studentMyclass'),
        meta: { title: '我的教室' }
      }, {
        path: 'classDetails',
        name: 'classDetails',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/classDetails'),
        meta: { title: '我的教室' }
      }, {
        path: 'classroomComments',
        name: 'classroomComments',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/classroomComments'),
        meta: { title: '课堂点评' }
      }, {
        path: 'myWorks',
        name: 'myWorks',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/myWorks'),
        meta: { title: '我的作品' }
      }, {
        path: 'classWorks',
        name: 'classWorks',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/classWorks'),
        meta: { title: '班级作品' }
      },
      {
        path: 'additionalWorks',
        name: 'additionalWorks',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/AdditionalWork'),
        meta: { title: '提交作业' }
      },
      // {
      //   path: 'detail',
      //   name: 'detail',
      //   component: () => import(/* webpackChunkName: "wuge" */ '@/components/work/WorkDetail'),
      //   meta: { title: '我的教室' }
      // }, 
      {
        path: 'mdView',
        name: 'mdView',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/MarkdownView'),
        meta: { title: '我的教室' }

      },
      {
        path: 'additionWork',
        name: 'additionWork',
        component: () => import(/* webpackChunkName: "wuge" */ '@/components/work/TeacherAdditionWork'),
        meta: { title: '布置作业', }
      },
      {
        path: 'workGroup',
        name: 'workGroup',
        component: () => import(/* webpackChunkName: "wuge" */ '@/components/work/TeacherWorkGroup'),
        meta: { title: '批改作业', }
      },
      {
        path: 'studentWorks',
        name: 'studentWorks',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/studentWorks'),
        meta: { title: '学生作品', }
      },
      {
        path: 'correctWorks',
        name: 'correctWorks',
        component: () => import(/* webpackChunkName: "wuge" */ '@/components/work/TeacherWorkList'),
        meta: { title: '批改列表', }
      },
      {
        path: 'workUnit',
        name: 'workUnit',
        component: () => import(/* webpackChunkName: "wuge" */ '@/components/work/TeacherWorkListUnitWrap'),
        meta: { title: '课程作业', }
      }
      , {
        path: 'LessonPreparationCenter',
        name: 'LessonPreparationCenter',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/LessonPreparationCenter'),
        meta: { title: '我的课程' }
      }, {
        path: 'courseDetail',
        name: 'courseDetail',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/CourseDetail'),
        meta: { title: '我的教室' }
      },
      // {
      //   path: 'trainingForTeachers',
      //   name: 'trainingForTeachers',
      //   component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/trainingForTeachers'),
      //   meta: { title: '我的教室' }
      // }, {
      //   path: 'teachingActivities',
      //   name: 'teachingActivities',
      //   component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/teachingActivities'),
      //   meta: { title: '我的教室' }
      // }, 
      {
        path: 'PointsMallPage',
        name: 'PointsMallPage',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/PointsMallPage'),
        meta: { title: '兑换记录' }
      },
      {
        path: 'StudentTimeline',
        name: 'StudentTimeline',
        component: () => import(/* webpackChunkName: "wuge" */ './views/report/StudentTimeline'),
        meta: { title: '成长记录' }
      },
      {
        path: 'departCalendar',
        name: 'departCalendar',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/DepartCalendar'),
        meta: { title: '班级课程表' }
      },
      {
        path: 'accountInfo',
        name: 'accountInfo',
        component: () => import(/* webpackChunkName: "wuge" */ './views/classroom/AccountInfo'),
        meta: { title: '账户中心' }
      }
    ]
  },
  {
    path: '/mockTest',
    component: mockTestLayout,
    redirect: '/mockTest/practise',
    children: [
      {
        path: 'practise',
        name: 'practise',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/practise'),
        meta: { title: '模拟测试', name: '我的练习' }
      }, {
        path: 'takeanexam',
        name: 'takeanexam',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/takeanexam'),
        meta: { title: '模拟测试', name: '我的考试' }
      }, {
        path: 'myPaper',
        name: 'myPaper',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/MyPaperAnswer'),
        meta: { title: '模拟测试', name: '我的答卷' }
      }, {
        path: 'wrongQuestion',
        name: 'wrongQuestion',
        component: () => import(/* webpackChunkName: "wuge" */ '@/components/exam/WrongQuestion'),
        meta: { title: '模拟测试', name: '错题本' }
      }, {
        path: 'questionBank',
        name: 'questionBank',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/questionBank'),
        meta: { title: '模拟测试', name: '题库中心' }
      }, {
        path: 'paperManage',
        name: 'paperManage',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/paperManage'),
        meta: { title: '模拟测试', name: '试卷中心' }
      }, {
        path: 'studentPractice',
        name: 'studentPractice',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/studentPractice'),
        meta: { title: '模拟测试', name: '学员练习' }
      }, {
        path: 'studentExams',
        name: 'studentExams',
        component: () => import(/* webpackChunkName: "wuge" */ './views/mockTest/studentExams'),
        meta: { title: '模拟测试', name: '学员考试' }
      },
    ]
  },

  // xinaoZoneLayout
  {
    path: '/xinaoZone',
    component: xinaoZoneLayout,
    redirect: '/xinaoZone/questionBank',
    children: [
      {
        path: 'questionBank',
        name: 'questionBank',
        component: () => import(/* webpackChunkName: "wuge" */ '@/components/exam/QuestionBank'),
        meta: { title: '信奥专区' }
      }, {
        path: 'questionHistory',
        name: 'questionHistory',
        component: () => import(/* webpackChunkName: "wuge" */ '@/components/exam/QuestionHistory'),
        meta: { title: '模拟测试', name: '答题记录' }
      }, {
        path: 'wrongQuestion',
        name: 'wrongQuestion',
        component: () => import(/* webpackChunkName: "wuge" */ '@/components/exam/WrongQuestion'),
        meta: { title: '模拟测试', name: '错题集' }
      },
    ]
  },
  {
    path: '/work',
    component: HomeLayout,
    redirect: '/work/list',
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import(/* webpackChunkName: "wuge" */ './views/work/WorkList'),
        meta: { title: '作品社区' }
      },
      {
        path: 'detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: "wuge" */ '@/components/work/WorkDetail')
      },

      {
        path: 'mdEditor',
        name: 'mdEditor',
        component: () => import(/* webpackChunkName: "wuge" */ './views/work/MarkdownEditor')
      },

    ]
  },
  {
    path: '/cms',
    component: HomeLayout,
    redirect: '/cms/list',
    children: [
      {
        path: 'index',
        name: 'cmsIndex',
        component: () => import(/* webpackChunkName: "wuge" */ './views/CmsListAuto')
      },
      {
        path: 'list',
        name: 'list',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cms/CmsList')
      },
      {
        path: 'detail',
        name: 'detail',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cms/CmsDetail')
      },
    ]
  },
  {
    path: '/course',
    name: 'course',
    redirect: '/course/index',
    component: HomeLayout,
    children: [
      {
        path: 'index',
        name: 'courseIndex',
        component: () => import(/* webpackChunkName: "wuge" */ './views/course/CourseList')
      },
      {
        path: 'detail',
        name: 'courseDetail',
        component: () => import(/* webpackChunkName: "wuge" */ './views/course/CourseDetail')
      },
    ]
  },
  {
    path: '/cert',
    component: BlankLayout,
    redirect: '/cert/query',
    hidden: true,
    children: [
      {
        path: '/cert/query',
        name: 'certQuery',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cert/CertQuery')
      },
      // {
      //   path: '/cert/score',
      //   name: 'scoreQuery',
      //   component: () => import(/* webpackChunkName: "wuge" */ './views/ScoreQuery')
      // },
      {
        path: '/cert/studentReport',
        name: 'studentReport',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cert/StudentCategoryReport')
      },
      {
        path: '/cert/schoolReport',
        name: 'schoolReport',
        component: () => import(/* webpackChunkName: "wuge" */ './views/cert/SchoolCategoryReport')
      }
    ]
  },
  {
    path: '/',
    component: FullScreenLayout,
    // redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "wuge" */ './views/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "wuge" */ './views/Register')
      }
    ]
  }
]
export default RouterMap